import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.helpers.branch-switch.';
  public static readonly branchSwitchConfirmation = `${Id.prefix}branchSwitchConfirmation`;
  public static readonly branchSwitchNotPartOfBranch = `${Id.prefix}branchSwitchNotPartOfBranch`;
}

export class LangBranchSwitch {
  private constructor() {}
  public static branchSwitchConfirmation(params: {
    resourceName: string;
    branchName: string;
    defaultBranchName: string;
  }): string {
    return interpolate(Id.branchSwitchConfirmation, params);
  }
  public static branchSwitchNotPartOfBranch(params: { resourceName: string }): string {
    return interpolate(Id.branchSwitchNotPartOfBranch, params);
  }
}

export class BranchSwitchModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.branchSwitchConfirmation,
      "the {{resourceName}} you are trying to open belongs to {{glossary 'branch'}} **'{{branchName}}'**\n\n**Do you want to switch {{glossary 'branch'}} to view the {{resourceName}}?**\n\nPress cancel to stay on {{glossary 'branch'}} **'{{defaultBranchName}}'**",
      'Confirmation message when switching branches to view a resource, uses markdown for formatting and includes branch and resource names'
    );
    register.add(
      Id.branchSwitchNotPartOfBranch,
      'this {{resourceName}} is not part of this branch and cannot be accessed',
      'Message shown when a resource is not part of the current branch'
    );
  }
}
